import { render, staticRenderFns } from "./SurveyVariableConfig.vue?vue&type=template&id=16393274&"
import script from "./SurveyVariableConfig.vue?vue&type=script&lang=js&"
export * from "./SurveyVariableConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports